const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function registerWebMcpTools() {
  const mc = navigator.modelContext;
  if (!mc || typeof mc.registerTool !== 'function') return;
  try {
    mc.registerTool({
      name: 'request_dental_appointment',
      description:
        'Submit an appointment request to Beechwood Dental Studio in Waterloo, Ontario. The clinic will phone or email the patient to confirm a time.',
      inputSchema: {
        type: 'object',
        properties: {
          name: { type: 'string', description: 'Patient full name' },
          email: { type: 'string', description: 'Patient email address' },
          phone: { type: 'string', description: 'Patient phone number' },
          service: { type: 'string', description: 'Requested service, e.g. cleaning, Invisalign consultation, emergency' },
          date: { type: 'string', description: 'Preferred date (YYYY-MM-DD), optional' },
          message: { type: 'string', description: 'Any additional details, optional' }
        },
        required: ['name', 'email', 'phone']
      },
      async execute(input) {
        const res = await fetch(`${API}/appointments`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(input)
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.detail || 'Appointment request failed');
        return {
          content: [{ type: 'text', text: 'Appointment request received. Beechwood Dental Studio will contact you to confirm a time.' }]
        };
      }
    });
  } catch (e) {
    /* WebMCP unavailable */
  }
}
